export * from './projekte-filter.component';
export * from './projekte-filter.component.module';